export function humanizeAttrVal(value: unknown): string {
    if (value === null || value === undefined || value === '') {
        return '-'
    }

    // this is more for non-technical users, so we want to show 'No' instead of 'false' etc.
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No'
    }

    if (typeof value === 'object') {
        return JSON.stringify(value)
    }

    return value as string
}

export function isUuid4(value: string): boolean {
    if (!value || typeof value !== 'string') {
        return false
    }

    const uuid4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

    return uuid4Regex.test(value)
}

export function removeSpacesFromString(value: string): string {
    return value.replace(/\s/g, '')
}
